import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import LocalStorageService from "./localStorageServices";

// ✅ extend plugins
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezonePlugin);

// ✅ Get user timezone (fallback: UTC)
// export const getUserTimezone = () => {
//   try {

//     const userData = localStorage.getItem("userDetails");
//     if (!userData) return "UTC";

//     const parsed = JSON.parse(userData);

//     if (parsed?.timezone?.name) {
//       return parsed.timezone.name; // e.g. "America/Los_Angeles"
//     }

//     return "UTC";
//   } catch (error) {
//     console.error("Error parsing userDetails:", error);
//     return "UTC";
//   }
// };
// type FormatType = "dateOnly" | "dateTime" | "timeOnly" | "full";
// ✅ Format date using user timezone
const localStorageServices = LocalStorageService.getService();

export function formatDate(date, type = "dateTime") {
  if (!date) return "";

  const user = localStorageServices.getCurrentUser().user;
  let userTZ = user?.timezone?.name;

  // ✅ Force UTC if timezone missing / invalid
  if (!userTZ || userTZ === "" || userTZ === undefined || userTZ === null) {
    userTZ = "UTC";
  }

  let d = dayjs.utc(date);

  // ✅ If timezone exists (not UTC fallback), convert
  if (userTZ !== "UTC") {
    try {
      d = d.tz(userTZ);
    } catch (err) {
      console.warn("Invalid timezone → forcing UTC");
      d = d.tz("UTC");
    }
  }

  switch (type) {
    case "dateOnly":
      return d.format("MMM D, YYYY"); // Apr 10, 2025

    case "dateTime":
      return d.format("MMM D, YYYY, h:mm A"); // Apr 10, 2025, 4:30 PM

    case "timeOnly":
      return d.format("h:mm A"); // 4:30 PM

    case "full":
      return d.format("dddd, MMMM D, YYYY, h:mm A"); // Thu, April 10, 2025, 4:30 PM

    default:
      return d.format(); // ISO fallback
  }
}

// capitalize and format text with spaces
const capitalize = (str) => {
  if (!str) return "";
  // First handle camelCase and PascalCase by adding spaces before capital letters
  // (but not at the start of the string)
  let result = str.replace(/-/g, " ");

  // Then capitalize the first letter of each word
  result = result.replace(/\b\w/g, (char) => char.toUpperCase()).trim();

  return result;
};
// get title
export const getTitle = (pathname, params) => {
  const segments = pathname.split("/").filter(Boolean); // removes empty segments

  // Handle /admin → Dashboard
  if (
    (segments.includes("admin") ||
      segments.includes("coach") ||
      segments.includes("super-admin")) &&
    segments.length < 2
  ) {
    return "Dashboard";
  }

  // Handle /admin/prospects/[id] → "Prospects Details"
  if (params?.slug && segments[segments.length - 1] === params.slug) {
    const secondLast = segments[segments.length - 2];
    if (capitalize(secondLast) === "Prospects") {
      return `${capitalize(secondLast)} Details`;
    }

    // ✅ NEW: Handle any other deep dynamic routes like /coach/calendar/schedule-details/[id]
    return capitalize(secondLast);
  }

  // Default: use the last segment
  return capitalize(segments[segments.length - 1]);
};

// breadcrumbs
const isId = (segment) => {
  // Check if segment is likely an ID (numbers, UUIDs, long strings)
  return (
    /^\d+$/.test(segment) || // Pure numbers
    /^[0-9a-f-]{36}$/i.test(segment) || // UUIDs
    /^[a-z0-9]{20,}$/i.test(segment)
  ); // Long alphanumeric IDs
};

export const getBreadcrumbs = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);

  return segments
    .filter((segment) => !isId(segment)) // Skip IDs
    .map((segment) => capitalize(segment.replace(/-/g, " "))); // Convert kebab-case and capitalize
};


export const getInitials = (name) => {
  if (!name) return "U";
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
  }
  const firstInitial = parts[0].charAt(0).toUpperCase();
  const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
  return `${firstInitial}${lastInitial}`;
};
